<template>
  <div id="home">
      <section
      class="section section--home"
      :class="{'section--home-full': (currentRestaurant.specials.length == 0)}"
      :style="{backgroundImage: (imgSettings.home_attachment && imgSettings.home_attachment.poster)? 'url(\'https://dev.jaifaim.ch/thumbnails/'+imgSettings.home_attachment.poster.profile+'/w1600q95/'+imgSettings.home_attachment.poster.path+'\')' : 'url(\''+require('@/assets/img/fond--home-2.png')+'\')' }"
      >
      <ul>
        <li :key="category.id" v-for="category in currentRestaurant.categories">
          <router-link v-if="category.specials.length == 0" :to="'/categories/'+category.id">
            <div>
              {{category | lang('name', $parent.lang)}}
            </div>
          </router-link>
          <router-link v-else :to="'/menus/'+category.id">
            <div>
              {{category | lang('name', $parent.lang)}}
            </div>
          </router-link>
        </li>
        <li>
          <router-link :to="'/drinks'">
            <div>
              {{$parent.statics.drinksTitle[$parent.lang]}}
            </div>
          </router-link>
        </li>
        <!--<li>
          <router-link :to="'/wine-types'">
            <div>
              {{$parent.statics.winesTitle[$parent.lang]}}
            </div>
          </router-link>
        </li>-->
      </ul>
    </section>
    <section
    class="section section--specials"
    v-if="currentRestaurant.specials.length > 0"
    >
      <div class="section__over">
        <p class="mb-0">
          <b>{{$parent.statics.specialTitle[$parent.lang]}}</b>
        </p>
      </div>
      <div
      class="section__content"
      :style="{backgroundImage: (imgSettings.home_special_attachment && imgSettings.home_special_attachment.poster)? 'url(\'https://dev.jaifaim.ch/thumbnails/'+imgSettings.home_special_attachment.poster.profile+'/w1600q95/'+imgSettings.home_special_attachment.poster.path+'\')' : 'url(\''+require('@/assets/img/fond--special.png')+'\')' }"
      >
        <ul>
          <li :key="special.id" v-for="special in currentRestaurant.specials">
            <router-link :to="'/specials/'+special.id">
              <div>
                {{special | lang('name', $parent.lang)}}
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>
<script>
  export default {
    name: 'home',
    data: function(){
      return {
        currentRestaurant: this.$parent.currentRestaurant,
        imgSettings: {}
      }
    },
    watch: {
      imgSettings: function(){
        this.$forceUpdate()
      }
    },
    created: function() {
      for(let i = 0; i < this.currentRestaurant.settings.length;i++){
        this.imgSettings[this.currentRestaurant.settings[i].key] = this.currentRestaurant.settings[i]
      }
    },
    mounted: function() {
      this.$parent.visibleHeader = true
    }
  };
</script>
